import angular from 'angular';

import gridHelpersService from './grid-helpers.service';

export default angular.module('dbm.dashboard.shared.grid-helpers', [])
.service('gridHelpers', gridHelpersService)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/shared/grid-helpers/index.js